import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { faCircleMinus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Modal } from '@platzi/ui';
import { getFollowSchools, unFollowSchool } from '../../../api';
import styles from './ModalUnfollow.module.sass';

const ModalUnfollow = (props) => {
  const { t } = useTranslation();
  const learningPathId = useSelector((state) => state.get('route').get('id')) || 0;
  const [userSchoolId, setUserSchoolId] = useState();

  useEffect(() => {
    getFollowSchools()
      .then((res) => {
        const followedLearningPathId = res.data?.filter((item) => item.learningPathId === learningPathId);
        setUserSchoolId(followedLearningPathId?.[0]?.id);
      })
      .catch((err) => {
        throw new Error('::ERROR::GET_FOLLOW_SCHOOLS', { cause: err });
      });
  }, []);

  const handleUnfollowRoute = () => {
    if (!userSchoolId) {
      getFollowSchools()
        .then((res) => {
          const followedLearningPathId = res.data?.filter((item) => item.learningPathId === learningPathId);
          unFollowSchool(followedLearningPathId?.[0]?.id);
          props.setUserFollowSchool(false);
          props.setShowModal(false);
        })
        .catch((err) => {
          throw new Error('::ERROR::GET_FOLLOW_SCHOOLS', { cause: err });
        });
    } else {
      unFollowSchool(userSchoolId)
        .then(() => {
          props.setUserFollowSchool(false);
          props.setShowModal(false);
        })
        .catch((err) => {
          throw new Error('::ERROR::FOLLOW_ROUTES_ADD-ROUTE-BUTTON', { cause: err });
        });
    }
  };

  return (
    <Modal show={props.showModal} close={props.closeModal}>
      <Card customClass={styles.Card}>
        <button
          className={styles.CloseModal}
          type="button"
          onClick={() => props.setShowModal(false)}
          data-testid="modal"
        >
          <FontAwesomeIcon icon={faTimes} size="sm" />
        </button>
        <div className={styles.CardHeader}>
          <span>
            <FontAwesomeIcon icon={faCircleMinus} />
          </span>
          <p>{t('route.modalUnfollow.title')}</p>
        </div>
        <div className={styles.CardBody}>
          <p>{t('route.modalUnfollow.description')}</p>
        </div>
      </Card>
      <div className={styles.CardFooter}>
        <Button customClass={styles.CancelButton} onClick={() => props.setShowModal(false)}>
          {t('route.modalUnfollow.cancel')}
        </Button>
        <Button onClick={handleUnfollowRoute}>{t('route.modalUnfollow.accept')}</Button>
      </div>
    </Modal>
  );
};

export default ModalUnfollow;
